var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-md-12" },
    [
      !_vm.modalVisible
        ? _c("v-table", {
            attrs: {
              column: _vm.colunas,
              data: _vm.dataComputed,
              actions: _vm.actionsTable
            },
            on: { show: _vm.show }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Solicitar Devolução", size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        id: "botao-salvar"
                      },
                      on: { click: _vm.salvaDevolucao }
                    },
                    [
                      _c("i", { staticClass: "fas fa-undo-alt" }),
                      _vm._v(" Devolver")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: { click: _vm.reset }
                    },
                    [_vm._v("\n                Cancelar\n            ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalDevolve,
            callback: function($$v) {
              _vm.modalDevolve = $$v
            },
            expression: "modalDevolve"
          }
        },
        [
          _c("b-card", [
            _c(
              "ul",
              { staticClass: "text-danger" },
              [
                _vm._l(_vm.errors, function(error) {
                  return _c("li", { key: error }, [_vm._v(_vm._s(error))])
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.danfe_id,
                      expression: "danfe_id"
                    }
                  ],
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.danfe_id },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.danfe_id = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.chave,
                      expression: "chave"
                    }
                  ],
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.chave },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.chave = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.revendedora_id,
                      expression: "revendedora_id"
                    }
                  ],
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.revendedora_id },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.revendedora_id = $event.target.value
                    }
                  }
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4" }, [
                _c("h5", [_vm._v("Revendedora")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("span", [_vm._v(_vm._s(_vm.danfe.nome))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4" }, [
                _c("h5", [_vm._v("Chave da Nota")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("span", [_vm._v(_vm._s(_vm.danfe.chave))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4" }, [
                _c("h5", [_vm._v("Número da Nota")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("span", [_vm._v(_vm._s(_vm.danfe.numero))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Tipo Devolução:")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tipo,
                          expression: "tipo"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "tipo-devolve" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.tipo = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { domProps: { value: 3 } }, [
                        _vm._v("Extravio / Perda")
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Tipo de Frete:")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.frete,
                          expression: "frete"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "tipo-frete" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.frete = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { domProps: { value: 1 } }, [
                        _vm._v("Proprio")
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 2 } }, [
                        _vm._v("Coleta")
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Justificativa:")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.justificativa,
                        expression: "justificativa"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      rows: "2",
                      cols: "3",
                      placeholder: "Digite aqui a sua o motivo da sua devolução"
                    },
                    domProps: { value: _vm.justificativa },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.justificativa = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Adicionar uma imagem:")]),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "file", name: _vm.image },
                    on: { change: _vm.addFile }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.tipo == 2
                ? _c("div", { staticClass: "form-group" }, [
                    _c("table", { staticClass: "table table-responsive" }, [
                      _c("thead", [
                        _c("th", [_vm._v("Selecione...")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Produto")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Descricao")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Quantidade")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.danfe.itens, function(itens) {
                          return _c("tr", { key: itens }, [
                            _c("td", [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: { type: "checkbox", name: "itens[]" },
                                on: {
                                  click: function($event) {
                                    return _vm.markDevolucao(itens.id)
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(itens.produto) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(itens.descricao) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(itens.quantidade) +
                                  "\n                                "
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3c2c3ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3c2c3ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_devolucao/DevolucaoAdm.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c3c2c3ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_devolucao/DevolucaoAdm.vue
// module chunks = 2